import React from 'react'
import { Grid, FormControl, TextField } from '@material-ui/core'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import { SecaoGenerica } from 'components'
import constants from 'utils/constants'

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  limit: 100,
})

export const FormEntregaRetorno = (props) => {
  const { form, setores, usuarios, verificarPermissao, currentUser, handleChangeUsuarioDestino } = props

  const getSetorLabel = (option) => {
    if (!option) return ''
    const nome = option.nome?.toUpperCase() || ''
    const divisao = option.divisao?.sigla?.toUpperCase() || ''
    const regional = option.divisao?.regional?.nome?.toUpperCase() || option.divisao?.regional?.sigla?.toUpperCase() || ''
    const orgao = option.divisao?.regional?.orgao?.sigla?.toUpperCase() || ''
    return `${nome} / ${divisao} / ${regional} / ${orgao}`
  }

  const getUsuarioLabel = (option) => {
    if (!option) return ''
    const nome = option.nome?.toUpperCase() || ''
    const cargo = option.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''
    return `${nome}${cargo}`
  }

  const handleSelectSetorOrigem = (event, newValue) => {
    form.setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        setOrig: newValue,
      },
    }))
  }

  const handleSelectUsuarioOrigem = (event, newValue) => {
    form.setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        usuOrig: newValue,
      },
    }))
  }

  const handleSelectUsuarioDestinoLocal = (event, newValue) => {
    handleChangeUsuarioDestino(newValue)
  }

  const handleSelectSetorDestino = (event, newValue) => {
    form.setFormState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        setDest: newValue,
      },
    }))
  }

  const setoresDestino = verificarPermissao([constants.PERMISSOES.RETORNAR_VESTIGIO_ADMINISTRADOR])
    ? form.formState.values.usuDest?.setores || []
    : currentUser?.setores || []

  return (
    <SecaoGenerica titulo="Dados da Entrega" spacing={2}>
      <Grid item md={10} sm={12} xs={12} style={{ marginBottom: '16px' }}>
        <Autocomplete
          name="setOrig"
          filterOptions={filterOptions}
          value={form.formState.values.setOrig || null}
          noOptionsText="Sem informações"
          options={setores}
          onChange={handleSelectSetorOrigem}
          getOptionLabel={getSetorLabel}
          getOptionSelected={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="SETOR ORIGEM"
              placeholder="Selecionar..."
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
          )}
        />
      </Grid>

      <Grid item md={10} sm={12} xs={12} style={{ marginBottom: '16px' }}>
        <Autocomplete
          name="usuOrig"
          filterOptions={filterOptions}
          value={form.formState.values.usuOrig || null}
          noOptionsText="Sem informações"
          options={usuarios}
          onChange={handleSelectUsuarioOrigem}
          getOptionLabel={getUsuarioLabel}
          getOptionSelected={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="USUÁRIO RESPONSÁVEL PELA ENTREGA"
              placeholder="Selecionar..."
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
          )}
        />
      </Grid>

      <Grid item md={10} sm={12} xs={12} style={{ marginBottom: '16px' }}>
        <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
          <TextField
            variant="outlined"
            fullWidth
            label="RESPONSÁVEL PELA ENTREGA - TEXTO LIVRE"
            InputLabelProps={{
              shrink: true,
            }}
            name="usuarioOrigemInput"
            value={form.formState.values.usuarioOrigemInput || ''}
            onChange={form.handleChange}
            disabled={form.formState.values.usuOrig?.nome?.toUpperCase() !== 'OUTRO'}
          />
        </FormControl>
      </Grid>

      {verificarPermissao([constants.PERMISSOES.RETORNAR_VESTIGIO_ADMINISTRADOR]) && (
        <>
          <Grid item md={10} sm={12} xs={12} style={{ marginBottom: '16px' }}>
            <Autocomplete
              name="usuDest"
              filterOptions={filterOptions}
              value={form.formState.values.usuDest || null}
              noOptionsText="Sem informações"
              options={usuarios}
              onChange={handleSelectUsuarioDestinoLocal}
              getOptionLabel={getUsuarioLabel}
              getOptionSelected={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="USUÁRIO RESPONSÁVEL PELO RECEBIMENTO"
                  placeholder="Selecionar..."
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                />
              )}
            />
          </Grid>
          <Grid item md={10} sm={12} xs={12} style={{ marginBottom: '16px' }}>
            <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
              <TextField
                variant="outlined"
                fullWidth
                label="RESPONSÁVEL PELO RECEBIMENTO - TEXTO LIVRE"
                InputLabelProps={{
                  shrink: true,
                }}
                name="usuarioDestinoInput"
                value={form.formState.values.usuarioDestinoInput || ''}
                onChange={form.handleChange}
                disabled={form.formState.values.usuDest?.nome?.toUpperCase() !== 'OUTRO'}
              />
            </FormControl>
          </Grid>
        </>
      )}

      <Grid item md={10} sm={12} xs={12} style={{ marginBottom: '16px' }}>
        <Autocomplete
          name="setDest"
          filterOptions={filterOptions}
          disabled={verificarPermissao([constants.PERMISSOES.RETORNAR_VESTIGIO_ADMINISTRADOR]) && !form.formState.values.usuDest}
          value={form.formState.values.setDest || null}
          noOptionsText="Sem informações"
          options={setoresDestino}
          onChange={handleSelectSetorDestino}
          getOptionLabel={getSetorLabel}
          getOptionSelected={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="SETOR DE RETORNO DO VESTÍGIO"
              placeholder="Selecionar..."
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
          )}
        />
      </Grid>
    </SecaoGenerica>
  )
}
